import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal, DatePicker, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { ProfileService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any;
	payment_methods: any;
	banks: any;
	item: any;
	onClose: any;
}

const TABS = {
	INFO: 1,
	FILES: 2
}

const INITIAL_STATE = {
	name: '',
	email: '',
	address: '',
	phone: '',
	document: '',
	bank_id: ''
}

class ModalAdd extends React.Component<Props> {

	state = {
		form: {
			payment_method_id: this.props.payment_methods[0]?.id || '',
			...INITIAL_STATE
		}
	}

	componentDidMount() {
		if (this.props.item) {
			const item = this.props.item;

			this.setState({
				form: {
					...this.state.form,
					payment_method_id: item?.payment_method_id,
					bank_id: item?.bank_id || '',
					name: item?.name || '',
					email: item?.email || '',
					address: item?.address || '',
					phone: item?.phone || '',
					document: item?.document || ''
				}
			});
		}
	}

	submit = async () => {
		const { payment_method_id, phone, document, bank_id, address, email, name } = this.state.form;

		let fields_required: any[] = [];

		switch(parseInt(payment_method_id)) {
			case Constants.PAYMENT_METHODS.PAYMENT_MOBILE:
				fields_required = [document,bank_id,phone];
			break;

			case Constants.PAYMENT_METHODS.TRANSFER:
				fields_required = [document,bank_id,address];
			break;

			case Constants.PAYMENT_METHODS.BITCOIN:
				fields_required = [address];
			break;

			case Constants.PAYMENT_METHODS.BINANCE:
				fields_required = [email];

				if (!Globals.validateEmail(email)) {
					Globals.showWarning("El correo electrónico no es válido");
					return;
				}
			break;

			case Constants.PAYMENT_METHODS.WALLY:
				fields_required = [email];

				if (!Globals.validateEmail(email)) {
					Globals.showWarning("El correo electrónico no es válido");
					return;
				}
			break;

			case Constants.PAYMENT_METHODS.ZELLE:
				fields_required = [email,name];

				if (!Globals.validateEmail(email)) {
					Globals.showWarning("El correo electrónico no es válido");
					return;
				}
			break;
		}

		if (fields_required.some(field => !field || field.toString().trim() === "")) {
			Globals.showWarning("Por favor, ingrese todos los datos para continuar");
			return;
		}

		await ProfileService.saveBankData({
			bank_data_id: this.props.item?.id,
			...this.state.form
		});
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		const { payment_methods } = this.props;
		const { payment_method_id } = this.state.form;

		return (
			<div id="modal-add-bank-data">
				<div className="row" style={{ marginBottom: '10px' }}>
					{
						payment_methods?.map((item: any) => {
							if (!this.props.item || item?.id == this.state.form.payment_method_id) {
								return (
									<div className={ !this.props.item ? 'col-md-4' : 'col-md-6' }>
										<button className={ `btn btn-payment-method ${ item?.id == this.state.form.payment_method_id ? 'active' : '' }` } disabled={ this.props.item } onClick={ () => {
											this.setState({
												form: {
													...INITIAL_STATE,
													payment_method_id: item?.id
												}
											}); 
										}}>
											{ item?.name }
											<img src={ Constants.BASE_PUBLIC + 'img/' + item?.icon } />
										</button>
									</div>
								)
							}
						})
					}
				</div>

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.PAYMENT_MOBILE && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									type="number"
									value={ this.state.form.phone }
									name="phone"
									label="Teléfono"
									onChange={ this.change }
									notMui
									maxLength={ 11 }
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.document }
									name="document"
									label="Nº de Cédula/RIF"
									onChange={ this.change }
									notMui
								/>
							</div>
							<div className="col-md-6">
								<Select
									name="bank_id"
									label="Banco"
									onChange={ (e: any) => this.change(e) }
									value={ this.state.form.bank_id }
									options={ this.props.banks?.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) }
								/>
							</div>
						</div>
					)
				}

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.TRANSFER && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.address }
									name="address"
									label="Número de cuenta"
									onChange={ this.change }
									notMui
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.document }
									name="document"
									label="Nº de Cédula/RIF"
									onChange={ this.change }
									notMui
								/>
							</div>
							<div className="col-md-6">
								<Select
									name="bank_id"
									label="Banco"
									onChange={ (e: any) => this.change(e) }
									value={ this.state.form.bank_id }
									options={ this.props.banks?.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) }
								/>
							</div>
						</div>
					)
				}

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.ZELLE && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.name }
									name="name"
									label="Nombre"
									onChange={ this.change }
									notMui
								/>
							</div>
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.email }
									name="email"
									label="Correo Electrónico"
									onChange={ this.change }
									notMui
								/>
							</div>
						</div>
					)
				}

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.BINANCE && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.email }
									name="email"
									label="Correo Electrónico"
									onChange={ this.change }
									notMui
								/>
							</div>
						</div>
					)
				}

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.BITCOIN && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.address }
									name="address"
									label="Billetera"
									onChange={ this.change }
									notMui
								/>
							</div>
						</div>
					)
				}

				{
					parseInt(payment_method_id) == Constants.PAYMENT_METHODS.WALLY && (
						<div className="row">
							<div className="col-md-6">
								<Input
									color="white"
									value={ this.state.form.email }
									name="email"
									label="Correo Electrónico"
									onChange={ this.change }
									notMui
								/>
							</div>
						</div>
					)
				}

				{
					payment_method_id != '' && (
						<div className="text-center">
							<Button type="submit" color="primary" onClick={ this.submit }>
								Guardar
							</Button>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalAdd);